module.exports = __webpack_public_path__ + "img/avatar-21.a46f483b.png";